import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import useBrandName from '@/hooks/use-brand-name';
import ApplicationImg from '@/assets/images/avantages/application.png'
import AbonnementImg from '@/assets/images/avantages/abonnement-premium.png'

const LibertyRider = () => {
    const brandName = useBrandName();
    return (
        <div className="mt-6">
            <Card>
                <CardContent className="p-6">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
                        <div className="md:col-span-4">
                            <img src={ApplicationImg} alt="Application" className="w-full rounded-lg" />
                        </div>
                        <div className="md:col-span-8">
                            <img src={AbonnementImg} alt="Abonnement Premium Offert" className="max-h-12" />
                            <h3 className="text-primary font-bold mt-6 text-lg">
                                Abonnement premium à l'application inclus gratuitement avec votre contrat APRIL&nbsp;Moto
                            </h3>
                            <p className="mt-6 text-muted-foreground">
                                L'application Liberty Rider détecte les accidents et contacte automatiquement les secours en cas de chute en moto.
                            </p>

                            <p className="mt-6 font-semibold">Comment en bénéficier ?</p>
                            <ol className="mt-2 space-y-1 text-sm text-muted-foreground list-decimal list-inside">
                                <li>Téléchargez l'application</li>
                                <li>Choisissez votre assurance {brandName}</li>
                                <li>Renseignez votre plaque d'immatriculation</li>
                            </ol>

                            <p className="mt-6 text-muted-foreground">
                                Bonne route avec APRIL&nbsp;Moto&nbsp;&&nbsp;Liberty&nbsp;Rider&nbsp;!
                            </p>

                            <Button asChild className="mt-6 cursor-pointer">
                                <a target="_blank" rel="noopener noreferrer" href="https://liberty-rider.com/fr/activation/april" className="no-underline text-white" aria-label="Profitez de l'offre Liberty Rider">
                                    <ExternalLink className="w-4 h-4" aria-hidden="true" />
                                    Profitez de l'offre
                                </a>
                            </Button>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default LibertyRider;
